/**
 * Fill glyphs for pastiradit letter shapes & matching eye borders.
 * Small on canvas; medium/bold weight for body — not hairline-thin.
 */

export const THIN_POOL = ".:'`*+-=~^\"_|/\\" as const;
export const BOLD_POOL = "#@%&80HMWX" as const;
export const MEDIUM_POOL = "+=*#%@08oaenst" as const;

export const GLYPH_POOL =
  `${THIN_POOL}${MEDIUM_POOL}01pastiraditPASTIRADIT${BOLD_POOL}` as const;

export const SCRAMBLE_POOL =
  "01@#%&*=+~^.:'`|/-_pastiraditHMW" as const;

const BOLD_SET = new Set(BOLD_POOL.split(""));

export function isBoldGlyph(ch: string): boolean {
  return BOLD_SET.has(ch);
}

export function randomGlyph(
  pool: string = GLYPH_POOL,
  rng: () => number = Math.random,
): string {
  return pool[(rng() * pool.length) | 0]!;
}

/**
 * ~55% bold/medium body, ~45% lighter marks — denser field, not ultra-thin.
 */
export function randomFillGlyph(rng: () => number = Math.random): string {
  const r = rng();
  if (r < 0.28) {
    return BOLD_POOL[(rng() * BOLD_POOL.length) | 0]!;
  }
  if (r < 0.55) {
    return MEDIUM_POOL[(rng() * MEDIUM_POOL.length) | 0]!;
  }
  if (r < 0.82) {
    return THIN_POOL[(rng() * THIN_POOL.length) | 0]!;
  }
  return randomGlyph(GLYPH_POOL, rng);
}

export function randomThinGlyph(rng: () => number = Math.random): string {
  return randomFillGlyph(rng);
}
